module.exports = __webpack_public_path__ + "static/img/4.6e26e6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/sp/4.png
// module id = kXu3
// module chunks = 0